function exportToCSV(filename, rows) {
  const csvContent = [
    ["Email", "Log Date", "Activity", "Message"], // headers
    ...rows.map((row) => [
      `"${row.email}"`,
      `"${row.logDate}"`,
      `"${row.activity}"`,
      `"${row.message}"`,
    ]),
  ]
    .map((e) => e.join(","))
    .join("\n");

  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");
  const url = URL.createObjectURL(blob);

  link.setAttribute("href", url);
  link.setAttribute("download", filename);
  link.style.visibility = "hidden";

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

export default exportToCSV;
